var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwarmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 35"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#SwarmLogo_svg__filter0_d_2393_10375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v29a2 2 0 01-2 2H21l-3 2H2a2 2 0 01-2-2V0z",
    fill: "#2CBDA7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.204 20.307c-.684 0-1.247-.037-1.8.023-.164.018-.38.28-.434.47-.3 1.06-.552 2.133-.827 3.198-.199.77-.546 1.042-1.344 1.047-1.172.007-2.345.01-3.516 0-1.013-.01-1.465-.6-1.216-1.593.595-2.378 1.184-4.757 1.802-7.13.554-2.126 2.283-3.526 4.486-3.679l.45-.032c.31-2.238 1.386-4.117 2.78-5.824a8.698 8.698 0 011.617-1.52c.806-.583 1.192-.353 1.297.65.237 2.27.204 4.504-.893 6.604l.133.172c.231-.115.578-.169.675-.356 1.499-2.854 4.12-4.136 7.02-4.956 1.086-.307 2.256-.377 3.394-.427.937-.042 1.11.331.757 1.177-1.003 2.403-2.7 4.117-5.08 5.159-.081.035-.17.06-.255.083-.017.006-.041-.009-.156-.041 1.332-1.096 2.494-2.28 3.262-3.824-1.54-.094-4.239 1.758-4.983 3.414l1.069-.274c-.303 1.166-.587 2.246-.865 3.328-.681 2.66-1.36 5.322-2.044 7.982-.21.817-.545 1.082-1.38 1.087-1.17.006-2.343.01-3.515 0-1.011-.008-1.455-.603-1.21-1.601.244-1.002.495-2.003.775-3.136l.001-.001zm-1.64-1.82c.69 0 1.267.02 1.84-.014.12-.007.294-.19.333-.322.177-.597.314-1.205.488-1.9-.67 0-1.267-.01-1.864.009-.104.004-.27.114-.296.205-.176.638-.322 1.283-.502 2.024l.002-.001z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "SwarmLogo_svg__filter0_d_2393_10375",
    x: 0,
    y: 0,
    width: 48,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.109804 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2393_10375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2393_10375",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/svg/SwarmLogo.svg";
export { SvgSwarmLogo as ReactComponent };